import submitsOnChanged from './submits-on-changed';
import productFilterGroups from './product-filter-groups';

export function exec () {
    productFilterGroups();
    submitsOnChanged();
}


// Toggle cuisine other option
/*
$('.toggle-option')
    .hide()
    .find(':input').attr('disabled','disabled');
$(function() {
    $('#RegisterAccountModel_SelectedCuisine').change(function(){
        if ($(this).val() == "62") {
            $('.toggle-option').find(':input').removeAttr('disabled');
            $('.toggle-option').slideDown();
        } else {
            $('.toggle-option').find(':input').attr('disabled','disabled');
            $('.toggle-option').slideUp();
        }
    });
});*/


// WEBPACK FOOTER //
// ./client/src/core/modules/forms/index.js